import { styled } from '@linaria/react';
import { useTranslation } from 'react-i18next';
import { baseWhite, secondaryBase } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Icon } from '../../../ui-library/icon/icon';
import { H3 } from '../../../ui-library/typography/typography';
import { DropShadowContainer } from '../../../components/drop-shadow-container/drop-shadow-container';

export function DataManagementHeader({
  title,
  icon,
  onClickBack,
}: {
  title: string;
  icon: string;
  onClickBack: () => void;
}) {
  const i18n = useTranslation();
  return (
    <DataManagementHeaderContainer>
      <Button
        radius="xl"
        size="sm"
        variant="secondary"
        onClick={onClickBack}
        leftSection={<Icon name="keyboard_backspace" color={baseWhite} />}
      >
        {i18n.t('common.actions.back')}
      </Button>
      <Icon style={{ marginLeft: 8 }} name={icon} color={secondaryBase} variant="outlined" size={28} />
      <H3>{title}</H3>
    </DataManagementHeaderContainer>
  );
}

const DataManagementHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DataManagementDropShadowContainer = styled(DropShadowContainer)`
  border-radius: 8px;
  width: 100%;
  height: calc(100vh - 172px);
  padding: 24px 16px 16px 16px;
`;
